<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="所属分类">
        <Cascader
          :data="catagoris"
          v-model="classify_ids"
          style="width:200px;"
        ></Cascader>
      </Form-item>
      <Form-item label="回复状态">
        <EnumSelect
          type="RepayStatus"
          selector="select"
          v-model="searchCondition.repay_status"
          style="width:200px"
        ></EnumSelect>
      </Form-item>
      <Form-item label="提问者">
        <Input
          style="width:200px"
          placeholder="提问者"
          v-model="searchCondition.user_name"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item label="标题">
        <Input
          style="width:200px"
          placeholder="请输入标题关键词"
          v-model="searchCondition.title"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <FormItem label="提问时间">
        <DatePicker
          type="daterange"
          placeholder="开始时间~截止时间"
          ref="askTime"
          v-model="askTime"
          @on-change="onAskTimeChange"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/ask/cask/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="c1">
          {{row.nickname}} 在
          <span style="color:blue">{{row.course_title}} > {{ row.course_periods_title }}</span>
          中提出了问题：
          {{ row.title}}
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" :to="{
            name: 'AnswerManage',
            query: { id: row.id, type: 2 }
            }">详情-</Button>

          <Button type="text" size="small" @click="deleteAsk(row)">删除</Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { RepayStatus } from "../../utils/enums.js";
export default {
  name: "AskCourse",
  data() {
    return {
      catagoris: [],
      classify_ids: [],
      searchCondition: {
        title: "",
        classify_id: 0,
        uid: "",
        repay_status: 0,
        start_time: "",
        end_time: "",
        user_name: ""
      },
      columns: [
        {
          title: "标题",
          slot: "c1",
          minWidth: 500
        },
        {
          title: "回复状态",
          key: "repay_status_text",
          minWidth: 90,
          align: 'center'
        },
        {
          title: "提问时间",
          key: "created_at",
          minWidth: 150,
          align: 'center'
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right"
        }
      ],
      askInfo: {
        id: "",
        name: "",
        catagoris: [],
        classify_ids: [],
        scope: false
      },
      selectList: [],
      askTime: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    catagoris.forEach(c => {
      c.value = c.id;
      c.label = c.name;
      c.children = c.child || [];
      c.children.forEach(child => {
        child.value = child.id;
        child.label = child.name;
      });
    });
    this.catagoris = catagoris;
    this.askInfo.catagoris = catagoris.filter(c => c.children.length > 0);
  },
  methods: {
    topAsk(row) {
      this.$http.put("/api/ask/changeTopHot",{id:row.id, type: 1}).then(res => {
        row.is_top = !row.is_top;
      });

    },
    hotAsk(row) {
      this.$http.put("/api/ask/changeTopHot",{id:row.id, type: 2 }).then(res => {
        row.is_hot = !row.is_hot;
      });
    },
    onAskTimeChange(range) {
      this.searchCondition.start_time = range[0];
      this.searchCondition.end_time = range[1];
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        if( row.answer_number > 0 ) {
          row.repay_status_text = '已回复'
        }else {
          row.repay_status_text = '未回复'
        }
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    async deleteAsk(row) {
      await this.$promiseConfirm("确定要删除该问题吗？");
      await this.$http.delete("/api/ask/delAsk",{id: row.id});
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      for (let i = 0; i < this.selectList.length; i++) {
        let bank = this.selectList[i];
        ids.push(bank.id);
      }
      await this.$promiseConfirm("确定要删除该问题吗？");
      let id = ids.join(",");
      await this.$http.delete("/api/ask/delAsk", { id });
      this.$refs.grid.refresh();
      this.selectList = [];
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.user_name = "";
        this.classify_ids = [];
        this.searchCondition.classify_id = 0;
        this.searchCondition.uid = "";
        this.searchCondition.title = '';
        this.askTime = [];
        this.searchCondition.repay_status='0';
          this.searchCondition.start_time = '';
          this.searchCondition.end_time = '';
      } else {
        if (this.classify_ids.length > 0) {
          this.searchCondition.classify_id = this.classify_ids[
            this.classify_ids.length - 1
          ];
        } else {
          this.searchCondition.classify_id = 0;
        }
        this.searchCondition.uid = this.onlyShowMine
          ? this.$store.state.user.id
          : "";
      }
      this.$refs.grid.searchRefresh();
    },
    async onMineChange() {
      await this.search(1);
    }
  }
};
</script>
